module.exports = __webpack_public_path__ + "img/link.e039580d.svg";